<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="editGym()" data-cy="edit-gym-button" *ngIf="isDownloaded && isAllowedToEditGym">
        {{"gym-details-page.edit" | translate}}
        <ion-icon slot="start" name="create"></ion-icon>
      </ion-button>
      <ion-button (click)="removeGym()" *ngIf="isAllowedToDeleteGym">
        <ion-icon name="trash" slot="start"></ion-icon>
      </ion-button>
      <ion-button (click)="qrCodeClicked()" *ngIf="isAllowedToDeleteGym">
        <ion-icon name="qr-code-outline" slot="start"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <loader *ngIf="!gym"></loader>
  <p *ngIf="!gym">{{"gym-details-page.load-gym-data" | translate}}</p>
  <div *ngIf="gym">
    <h1>{{gym.gymName}}</h1>
    <h2 *ngIf="gym.timeCreated" translate [translateParams]="{date:gym.timeCreated|dateFormat}">
      gym-details-page.added-on
    </h2>

    <br>

    <ion-item *ngIf="gym.gymRules?.length > 0" class="gym-rules">
      <ion-icon slot="start" name="information-circle-outline"></ion-icon>
      <span slot="start">{{"gym-details-page.gym-rules" | translate}}:</span><b slot="end">{{gym.gymRules}}</b>
    </ion-item>

    <ion-item *ngIf="gym.isPrivate">
      <ion-icon slot="start" name="lock-closed-outline"></ion-icon>
      <p><b>{{"gym-details-page.private-gym" | translate}}</b></p>
    </ion-item>

    <ion-item>
      <ion-icon slot="start" name="location-outline"></ion-icon>
      <p *ngIf="gym.address">{{gym.address?.trim()}}, </p>{{gym.city?.trim()}}, {{gym.country?.trim()}}
    </ion-item>

    <ion-item>
      <ion-icon slot="start" name="person-circle-outline"></ion-icon>
      {{"gym-details-page.admin" | translate}}:<p>&nbsp;<b>{{gymAdminsString}}</b></p>
    </ion-item>

    <ion-item detail="true" (click)="manageWalls()" *ngIf="isActive">
      <ion-icon name="camera" slot="start"></ion-icon>
      {{"gym-details-page.walls-and-photos" | translate}}
    </ion-item>

    <ion-item detail="true" (click)="share()">
      <ion-icon slot="start" name="share-social-outline"></ion-icon>
      {{"boulder-details-page.share-it" | translate}}
    </ion-item>

    <br>

    <ion-item color="primary" detail="true" [routerLink]="'//tabs/boulder-list'" *ngIf="isActive && isDownloaded">
      {{"gym-details-page.show-boulders" | translate}}
    </ion-item>

    <ion-item class="remove-from-downloads" (click)="onRemove()" *ngIf="isDownloaded">
      <ion-icon slot="start" name="close-circle-outline"></ion-icon>
      {{"gym-details-page.remove-from-list" | translate}}
    </ion-item>

    <ion-item color="primary" detail="true" (click)="activate()" *ngIf="!isActive && isDownloaded">
      {{"gym-details-page.activate" | translate}}
    </ion-item>

    <ion-item color="primary" data-cy="download-gym-button" *ngIf="!isDownloaded" (click)="downloadAndActivate()">
      <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
      {{"gym-details-page.load-gym" | translate}}
    </ion-item>
  </div>
</ion-content>
